export default "__VITE_ASSET__DsmMkir$__"